
import './navbar.css'
import logo1 from '../../assets/logo1.png'
import logo2 from '../../assets/logoLight.png'
import {GiHamburgerMenu} from 'react-icons/gi'
import {RiCloseCircleLine} from 'react-icons/ri'
import {useState} from  'react'
import { useEffect } from 'react'
import {HashLink} from 'react-router-hash-link'
import {motion} from 'framer-motion'
function Navbar() {
  const [theme,setTheme] = useState('dark-theme')
  const [menu,setMenu] = useState('close')
  const toggleMenu = () =>{
    menu == 'close' ? setMenu('open') : setMenu('close')
  }
  const toggleTheme = () =>{
    theme == 'dark-theme' ? setTheme('light-theme') : setTheme('dark-theme');
  }
  useEffect(()=>{
    document.body.className = theme;

  },[theme])
  const [navActive,setNavActive] = useState('#')
  const navClickClose = (val) =>{
    switch(val){
      case '#' : setNavActive('#')
                      setMenu('close')
                      break;
      case 'about' : setNavActive('#about')
                      setMenu('close');
                      break;
      case 'projects' : setNavActive('#projects')
                        setMenu('close');
                      break;
      case 'skills' : setNavActive('#skills')
                      setMenu('close');
                      break;
      case 'contact' : setNavActive('#contact')
                        setMenu('close');
                      break;
                      
    }
    
    
  }
  return (
    <motion.nav
    initial={{
      opacity :0,
      top: '-3rem'
    }}
    animate={{
      opacity:1,
      top: '1rem'
    }}
    transition={{
      duration:0.5,
      ease: "easeInOut",type: "spring", stiffness: 300, damping: 20
    }}>
      
      <img src={
            theme == 'dark-theme' ? logo1 : logo2
          }
      alt="logo" className='logo' />
      <ul className={menu == 'close' ? 'navlink' : 'navlink active'}>
        <button onClick={()=>{navClickClose('#')}} className={navActive == '#'?'nav-active':null}><HashLink smooth to="#">Home</HashLink></button>
        <button onClick={()=>{navClickClose('about')}} className={navActive == '#about'?'nav-active':null}><HashLink smooth to="#about">About Me</HashLink></button>
        <button onClick={()=>{navClickClose('projects')}} className={navActive == '#projects'?'nav-active':null}><HashLink smooth to="#projects">Projects</HashLink></button>
        <button onClick={()=>{navClickClose('skills')}} className={navActive == '#skills'?'nav-active':null}><HashLink smooth to="#skills">Skills</HashLink></button>
        <button onClick={()=>{navClickClose('contact')}} className={navActive == '#contact'?'nav-active':null}><HashLink smooth to="#contact">Contacts</HashLink></button>
      </ul>
      <div className="navbar-right-part">
        {/* <li onClick={toggleTheme}>
          {
            theme == 'dark-theme' ? <FiSun /> : <MdOutlineNightsStay />
          }
        </li> */}
        <button onClick={toggleMenu} className="toggleMenuBtn">
        {
          menu == 'close'? <GiHamburgerMenu /> : <RiCloseCircleLine />
        }
        </button>
      </div>
    </motion.nav>
  )
}

export default Navbar